import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { BsChevronRight } from "react-icons/bs";
import PubSub from "pubsub-js";


const ContactView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [client, setClientclient] = useState(location.state ? location.state.id : {});
  const [modalShow, setModalShow] = useState(false);
  
    //Commented Due to some fields on 24-Dec-2024
    useEffect(() => {
      fetchclient();
    }, []);

    const fetchclient = async () => {
      // if (!client.id && location.hasOwnProperty("pathname")) {
      //   client.id = location.pathname.split("/")[2];
      //   //console.log("pathnam===" + contact.id);
      // }
      let challanRecords = await trasportApi.fetchChallanById(location.state ? location.state.id : client.id);

      if(challanRecords){
        setClientclient(challanRecords);
      }
    }

  const isdelete = async () => {
    let result = await trasportApi.deleteChallan(client.id);
    if (result.success){
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record deleted successfully' });
        navigate(`/challans`);
    } 
  };

  const editclient = () => {
    navigate(`/challans/${client.id}/e`, { state: client });
  };
  console.log("client",client)
  return (
    <Main>
      <>
        <Helmet>
          <title>
             {`${client.challan_name}`} 
          </title>
        </Helmet>
      </>
      <div>
        {client && (
          <Container>
            {modalShow && (
              <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              isdelete={isdelete}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="client"
            />
            )}

        
            <Col lg={2} className="mx-2">
              <Link to="/home" style={{ "text-decoration": "none" }}>
                Home
              </Link>{" "}
              {/* <i className="fa-solid fa-chevron-right"></i> */}
              <BsChevronRight/>
              <Link to="/challans" style={{ "text-decoration": "none" }}>
              Challan
              </Link>
            </Col>
            <Row className="view-form">
              <Col></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={4}>
                    {/* <div>client Id: {client.contactno}</div> */}
                    <h5>
                      {client.client_name}{" "}
                    </h5>
                  </Col>
                  <Col lg={8} className="d-flex justify-content-end">
                      <Button
                        className="btn-sm mx-2"
                        onClick={() => editclient(true)}
                        >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                      <label>Branch Name</label>
                      <span>{client.branch_name || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Challan No</label>
                      <span>{client.challan_no || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Challan Date</label>
                      <span>{new Date(client.challan_date).toLocaleString() || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Client Name</label>
                      <span>{client.client_name || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Client Balance</label>
                      <span>{client.client_balance || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Client Commission Amount</label>
                      <span>{client.client_commission_amount || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Client Commission Rate</label>
                      <span>{client.client_commission_rate || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Commission Fixed</label>
                      <span>{client.commission_fixed || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Dispatch Weight</label>
                      <span>{client.dispatch_weight || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Financial Year</label>
                      <span>{client.financial_year_name || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>G.R. No</label>
                      <span>{client.g_r_no || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Item Deduction Rate</label>
                      <span>{client.item_deduction_rate || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Rate</label>
                      <span>{client.rate || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Vehicle Number</label>
                      <span>{client.vehicle_number || ""}</span>
                    </Col>

                    {/* Section for Additional Information */}
                    <Col lg={12}>
                      <Col className="section-header my-3">
                        <span style={{ color: "blue", paddingLeft: "10px" }}>
                          Additional Information
                        </span>
                      </Col>
                    </Col>
                    <Col lg={6}>
                      <label>Commission</label>
                      <span>{client.commission || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Consignee</label>
                      <span>{client.consignee || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Constant Rate</label>
                      <span>{client.constant_rate || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>DO No</label>
                      <span>{client.d_o_no || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Grade</label>
                      <span>{client.grade || ""}</span>
                    </Col>

                    {/* Section for Bank Information */}
                    <Col lg={12}>
                      <Col className="section-header my-3">
                        <span style={{ color: "blue", paddingLeft: "10px" }}>
                          User Information
                        </span>
                      </Col>
                    </Col>
                    <Col lg={6}>
                      <label>Created By</label>
                      <span>{client.createdbyname || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Created Date</label>
                      <span>{new Date(client.createddate).toLocaleString() || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Last Modified By</label>
                      <span>{client.lastmodifiedbyname || ""}</span>
                    </Col>
                    <Col lg={6}>
                      <label>Last Modified Date</label>
                      <span>{new Date(client.lastmodifieddate).toLocaleString() || ""}</span>
                    </Col>
                  </Row>

              </Col>
              <Col></Col>
             
            </Row>
          </Container>
        )}
      </div>
    </Main>
  );
};
export default ContactView;
